import React, { useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css"; //https://www.creative-tim.com/blog/web-design/how-to-use-bootstrap-with-reactjs/
import createCache from '@emotion/cache';
import LoadingButton from '@mui/lab/LoadingButton';
import { Link, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from "react-promise-tracker";
import { Switch, Checkbox, Button, TextField, Modal, Box, Grid, Stack, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormGroup, FormControl, FormLabel, FormControlLabel, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Moment from 'moment';
import { Bars, MagnifyingGlass } from "react-loader-spinner";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


export default function EventsByGameSource(props) {
    const { search } = useLocation()
    const values = queryString.parse(search)
    const [gameSource, setGameSource] = useState(props.gameSource ? props.gameSource : (values.gameSource ? values.gameSource : ""));
    //const [gameSource, setGameSource] = useState(props.gameSource ? props.gameSource : "");
    const [status, setStatus] = useState("");
    
    /*var today = Moment().format("YYYY-MM-DD");*/
    const [importDate, setImportDate] = useState(props.importDate ? props.importDate : Moment().format("YYYY-MM-DD"));
    
    const { promiseInProgress } = usePromiseTracker();
    const [statusColor, setStatusColor] = useState();
    const [token, setToken] = useState();
    const [authenticated, setAuthenticated] = useState(false);
    const [events, setEvents] = useState([]);
    const [downloading, setDownloading] = useState(false);
    const [waiting, setWaiting] = useState(false);
    const [searching, setSearching] = useState(false);
    
    
    const centerDivStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '20vh'
    }; //https://www.c-sharpcorner.com/blogs/how-to-make-a-div-center-in-screen-in-react-js

    useEffect(async (e) => {
        setAuthenticated(await authService.isAuthenticated());
        var ttt = await authService.getAccessToken();
        await setToken(ttt);

        if (gameSource) {
            getEventsByGameSource()
        }
            
    }, []);

    const getEventsByGameSource = async () => {
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }
        trackPromise(
            axios.get('/api/chessgames/GetEventsByGameSource?gameSource=' + gameSource, headers).then((response) => {
                let evts = response.data;
                setEvents(evts);
                setDownloading(false);
                if (evts.length > 0) {
                    setStatusColor("green");
                    setStatus(evts.length + " events found.");
                } else {
                    setStatusColor("red");
                    setStatus("No events found");
                }

            }).catch((error) => {
                setDownloading(false);
                setStatusColor("red");
                setStatus(error.response.data);
                console.log(error.response.data);
            })
        )

    };

    return (

        <div>
            <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={true}>
                <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#1976d2' }}>
                    <Typography color='white'><span>{gameSource.length > 0 ? 'Find Events Imported From ' + gameSource + ' ' : 'Find Events '}</span><span style={{ color: statusColor }}>{status}</span></Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                        <Grid item xs={6} lg={6}>
                            <Stack>
                                <TextField
                                    fullwidth="true"
                                    size="small"
                                    label={'Game Source'}
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    value={gameSource}
                                    onChange={async (e) => { setGameSource(e.target.value) }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label='Import Date'
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    type='date'
                                    value={importDate}
                                    onChange={async (e) => { setImportDate(e.target.value) }}
                                    error={!importDate}
                                    helperText={!importDate ? 'Required' : ''}
                                    defaultValue={importDate}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <Stack>
                                <LoadingButton
                                    onClick={async (e) => { await setDownloading(true); await getEventsByGameSource(); }}
                                    loading={downloading}
                                    disabled={!gameSource}
                                    loadingIndicator="Wait"
                                    variant="contained"
                                    color="primary"
                                >
                                    Search
                                </LoadingButton>
                            </Stack>
                        </Grid>

                    </Grid>
                </AccordionDetails>
                <AccordionDetails>
                        {(promiseInProgress === true) ?
                            <div>
                                <Box sx={{ pt: 2, pb: 1 }}>
                                    <div style={centerDivStyle}>
                                        <MagnifyingGlass ariaLabel="Loading" color="#00BFFF" />
                                    </div>
                                </Box>
                            </div>
                            :
                            <div>
                                {events.length > 0 &&
                                    <div>
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">Source</TableCell>
                                                        <TableCell align="left">Event</TableCell>
                                                        <TableCell align="left">Starts</TableCell>
                                                        <TableCell align="left">Ends</TableCell>
                                                        <TableCell align="left">Games</TableCell>
                                                        <TableCell align="left">FIDE ID</TableCell>
                                                        <TableCell align="left">USCF ID</TableCell>
                                                        <TableCell align="left">Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {events.map((tournament) => (
                                                        <TableRow
                                                            key={tournament.Event}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell component="th" scope="row">{tournament.gameSource}</TableCell>
                                                            <TableCell component="th" scope="row">
                                                                <Link target="_blank" to={'/EventGames/Update?eventName=' + tournament.event + '&eventStartDate=' + Moment(tournament.eventStartDate, 'YYYY-MM-DD').add(-10, 'days').format("YYYY-MM-DD") + '&eventEndDate=' + Moment(tournament.eventEndDate, 'YYYY-MM-DD').add(10, 'days').format("YYYY-MM-DD") }> {tournament.event} </Link>
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">{tournament.eventStartDate}</TableCell>
                                                            <TableCell component="th" scope="row">{tournament.eventEndDate}</TableCell>
                                                            <TableCell component="th" scope="row">{tournament.games}</TableCell>
                                                            <TableCell align="right">{tournament.fideEventId > 0 ? <a target="_blank" href={"https://ratings.fide.com/tournament_information.phtml?event=" + tournament.fideEventId} >{tournament.fideEventId}</a> : tournament.fideEventId}</TableCell>
                                                            <TableCell align="right">{tournament.uscfEventId > 0 ? <a target="_blank" href={"https://www.uschess.org/msa/XtblMain.php?" + tournament.uscfEventId} >{tournament.uscfEventId}</a> : tournament.uscfEventId}</TableCell>
                                                            <TableCell component="th" scope="row">
                                                                <Button component={Link} target="_blank" to={'/EventGames/Update?eventName=' + tournament.event + '&gameSource=' + tournament.gameSource + '&eventStartDate=' + tournament.eventStartDate + '&eventEndDate=' + tournament.eventEndDate} variant="contained" color="primary">
                                                                    Edit
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                }
                            </div>

                        }
                </AccordionDetails>
            </Accordion>
            
            
        </div>

    )
}

